import { styled } from "goober";
import { PressButton } from "./PressButton";

const Track = styled("span")`
  display: block;
  padding: 3px;
  width: 30px;
  height: 20px;
  box-sizing: border-box;
  flex-shrink: 0;
  border-radius: 12px;
  transition: background-color 120ms ease-out;

  &[data-on="true"] {
    background-color: var(--green-600);
  }
  &[data-on="false"] {
    background-color: var(--alpha8);
  }
`;

const Dial = styled("span")`
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--text-white);
  box-shadow: var(--elevation-low);
  transition: transform 120ms ease-out;

  &[data-on="true"] {
    transform: translateX(10px);
  }
  &[data-on="false"] {
    transform: translateX(0);
  }
`;

// For a surface that is itself the switch, like a dropdown row, where a nested
// control would take the press twice.
export function ToggleVisual({ isOn }: { isOn: boolean }) {
  return (
    <Track data-on={String(isOn)}>
      <Dial data-on={String(isOn)} />
    </Track>
  );
}

type Props = {
  isOn: boolean;
  onToggle: () => void;
  disabled?: boolean;
  ariaLabel?: string;
};

export function Toggle({ isOn, onToggle, disabled, ariaLabel }: Props) {
  return (
    <PressButton
      onPress={onToggle}
      disabled={disabled}
      role="switch"
      aria-label={ariaLabel}
      aria-checked={isOn}
    >
      <ToggleVisual isOn={isOn} />
    </PressButton>
  );
}
